import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import moment from "moment"
import DatePicker from "react-datepicker"
import Button from "../../components/button"
import CSCharacterImage from "../../images/announce_character.png"
import EmailHeaderImage from "../../images/email-header.png"
import WebsiteLogoImage from "../../images/bluuu-logo.png"
import ContactEmail from "../../images/contact-email.png"
import OffIcon from "../../images/off-icon.png"
import SuccessIcon from "../../images/success.svg"
import WarningIcon from "../../images/warning.svg"
import request from "../../utils/request"

import "./csAnnouncement.css"

const SUCCESS_MODAL_DURATION = 2000
const TIME_INTERVALS = 15
const WEBSITE_SECTION = "website"
const EMAIL_SECTION = "email"
const PREVIEW_POPUP_BOTTOM_GAP = 16
const PREVIEW_MESSAGE_DURATION = 12000
const PREVIEW_LEAVE_DURATION = 220

const getDefaultStartDate = () => {
  const date = new Date()
  // date.setMinutes(date.getMinutes() + 15)

  return date
}

const getDefaultEndDate = () => {
  const date = getDefaultStartDate()
  date.setHours(date.getHours() + 2)

  return date
}

const createAnnouncementState = () => {
  const startDate = getDefaultStartDate()
  const endDate = getDefaultEndDate()

  return {
    id: null,
    subjectTH: null,
    messageTH: null,
    subjectEN: null,
    messageEN: null,
    startDate,
    endDate,

    isActive: false,
    isPreviewVisible: false,
    isPreviewMessageVisible: false,
    isPreviewAtBottom: false,
    isPreviewScrolling: false,
    isPreviewMessageLeaving: false,
    isPreviewPromptLeaving: false,
    hasOpenedPreviewMessage: false,
    scrollTimer: null,
    previewLanguage: "th",

    messageAlignmentTH: "left",
    messageAlignmentEN: "left",

    isExpanded: true,
    isEditing: false,

    isSuccessModalVisible: false,
    isSaving: false,

    savedForm: {
      subjectTH: null,
      messageTH: null,
      subjectEN: null,
      messageEN: null,
      messageAlignmentTH: "left",
      messageAlignmentEN: "left",
      startDate: new Date(startDate.getTime()),
      endDate: new Date(endDate.getTime()),
    },

    error: {
      type: "",
      message: "",
      fields: [],
    },
  }
}

const createActivationConfirmState = () => ({
  isOpen: false,
  sectionKey: null,
  title: "",
  action: "activate",
})

class BroadcasManagementLayout extends Component {
  constructor(props) {
    super(props)

    this.successModalTimers = {}
    this.previewMessageTimers = {}
    this.previewScrollTimers = {}
    this.previewLeaveTimers = {}
    this.promptLeaveTimers = {}
    this.previewStageRefs = { [WEBSITE_SECTION]: React.createRef() }
    this.previewPopupRef = React.createRef()
    this.previewCharacterRef = React.createRef()
    this.statusTimer = null

    this.state = {
      website: createAnnouncementState(),
      email: createAnnouncementState(),
      activationConfirm: createActivationConfirmState(),
      noticeModal: {
        isOpen: false,
        sectionKey: null,
      },
    }
  }

  componentDidMount() {
    this.props.setPageTitle("CS Announcement")
    this.props.showBackIcon(false)
    this.fetchAnnouncement()

    this.statusTimer = setInterval(() => {
      this.setState({ currentTime: new Date() }, this.updateExpiredAnnouncements)
    }, 30000)
  }

  componentWillUnmount() {
    if (this.statusTimer) {
      clearInterval(this.statusTimer)
      this.statusTimer = null
    }

    ;[
      this.successModalTimers,
      this.previewMessageTimers,
      this.previewScrollTimers,
      this.previewLeaveTimers,
      this.promptLeaveTimers,
    ].forEach((timers) => {
      Object.values(timers).forEach((timerId) => timerId && clearTimeout(timerId))
    })
  }

  fetchAnnouncement = async () => {
    try {
      const response = await request.get("announcement-cs/all")

      const responseData = response?.data || response

      if (!responseData) {
        return
      }

      const announcementList = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.data)
          ? responseData.data
          : []

      const website = announcementList.find((item) => item.type === WEBSITE_SECTION) || {}
      const email = announcementList.find((item) => item.type === EMAIL_SECTION) || {}

      const websiteStartDate = website.start_datetime
      const websiteEndDate = website.end_datetime
      const emailStartDate = email.start_datetime
      const emailEndDate = email.end_datetime

      const websiteMessageTH = website.message_th || ""
      const websiteMessageEN = website.message_en || ""

      const websiteAlignmentTH = this.getHtmlAlignment(websiteMessageTH)
      const websiteAlignmentEN = this.getHtmlAlignment(websiteMessageEN)

      const websitePlainTextTH = this.htmlToText(websiteMessageTH)
      const websitePlainTextEN = this.htmlToText(websiteMessageEN)

      this.setState({
        website: {
          ...this.state.website,
          id: website.id || null,
          subjectTH: website.subject_th || null,
          messageTH: websitePlainTextTH || null,
          subjectEN: website.subject_en || null,
          messageEN: websitePlainTextEN || null,
          messageAlignmentTH: websiteAlignmentTH,
          messageAlignmentEN: websiteAlignmentEN,
          startDate: websiteStartDate
            ? new Date(websiteStartDate.replace("Z", ""))
            : this.state.website.startDate,
          endDate: websiteEndDate
            ? new Date(websiteEndDate.replace("Z", ""))
            : this.state.website.endDate,
          isActive: Boolean(website.is_active),

          savedForm: {
            subjectTH: website.subject_th || null,
            messageTH: websitePlainTextTH || null,
            subjectEN: website.subject_en || null,
            messageEN: websitePlainTextEN || null,
            messageAlignmentTH: websiteAlignmentTH,
            messageAlignmentEN: websiteAlignmentEN,
            startDate: websiteStartDate
              ? new Date(websiteStartDate.replace("Z", ""))
              : this.state.website.startDate,
            endDate: websiteEndDate
              ? new Date(websiteEndDate.replace("Z", ""))
              : this.state.website.endDate,
          },
        },

        email: {
          ...this.state.email,
          id: email.id || null,
          subjectTH: email.subject_th || null,
          messageTH: email.message_th || null,
          subjectEN: email.subject_en || null,
          messageEN: email.message_en || null,
          startDate: emailStartDate
            ? new Date(emailStartDate.replace("Z", ""))
            : this.state.email.startDate,
          endDate: emailEndDate
            ? new Date(emailEndDate.replace("Z", ""))
            : this.state.email.endDate,
          isActive: Boolean(email.is_active),
          savedForm: {
            subjectTH: email.subject_th || null,
            messageTH: email.message_th || null,
            subjectEN: email.subject_en || null,
            messageEN: email.message_en || null,
            startDate: emailStartDate
              ? new Date(emailStartDate.replace("Z", ""))
              : this.state.email.startDate,
            endDate: emailEndDate
              ? new Date(emailEndDate.replace("Z", ""))
              : this.state.email.endDate,
          },
        },
      })
    } catch (error) {
      console.error("fetchAnnouncement error:", error)
    }
  }

  /* -------------------------------------------------------------------------- */
  /* Helpers                                                                    */
  /* -------------------------------------------------------------------------- */

  getSection = (sectionKey) => {
    return this.state[sectionKey]
  }

  updateSection = (sectionKey, updates) => {
    this.setState((prevState) => ({
      [sectionKey]: {
        ...prevState[sectionKey],

        ...updates,
      },
    }))
  }

  getSectionStatus = (sectionKey) => {
    const section = this.getSection(sectionKey)
    const now = moment()
    const startDate = moment(section.startDate)
    const endDate = moment(section.endDate)

    if (
      !section.isActive ||
      !startDate.isValid() ||
      !endDate.isValid() ||
      now.isSameOrAfter(endDate)
    ) {
      return "INACTIVE"
    }

    if (now.isBefore(startDate)) {
      return "SCHEDULED"
    }

    return "ACTIVE"
  }

  updateExpiredAnnouncements = () => {
    const now = moment()

    ;[WEBSITE_SECTION, EMAIL_SECTION].forEach((sectionKey) => {
      const section = this.getSection(sectionKey)
      const endDate = moment(section.endDate)

      if (section.isActive && endDate.isValid() && now.isSameOrAfter(endDate)) {
        this.updateSection(sectionKey, {
          isActive: false,
        })
      }
    })
  }

  shouldShowExpiredWarning = (sectionKey) => {
    const section = this.getSection(sectionKey)
    const endDate = moment(section.endDate)

    if (!endDate.isValid()) {
      return false
    }

    return moment().isSameOrAfter(endDate)
  }

  getActivationConfirmTitle = (title) => {
    const titleMap = {
      Website: "Website Announcement",
      "Email Auto-reply": "Email Auto-Reply",
    }

    return titleMap[title] || title
  }

  isInvalidSchedule = (section) => {
    return moment(section.endDate).isSameOrBefore(moment(section.startDate))
  }

  hasEmptyFields = (section) => {
    const hasValue = (value) => Boolean(value && value.trim())

    return (
      !hasValue(section.subjectTH) ||
      !hasValue(section.messageTH) ||
      !hasValue(section.subjectEN) ||
      !hasValue(section.messageEN)
    )
  }

  hasMissingRequiredFields = (section) => {
    const hasValidStartDate = section.startDate && moment(section.startDate).isValid()
    const hasValidEndDate = section.endDate && moment(section.endDate).isValid()
    const hasSubjectTH = Boolean(section.subjectTH && section.subjectTH.trim())
    const hasMessageTH = Boolean(section.messageTH && section.messageTH.trim())
    const hasSubjectEN = Boolean(section.subjectEN && section.subjectEN.trim())
    const hasMessageEN = Boolean(section.messageEN && section.messageEN.trim())

    return (
      !hasValidStartDate ||
      !hasValidEndDate ||
      !hasSubjectTH ||
      !hasMessageTH ||
      !hasSubjectEN ||
      !hasMessageEN
    )
  }

  closeSuccessModal = (sectionKey) => {
    this.updateSection(sectionKey, {
      isSuccessModalVisible: false,
    })

    this.successModalTimers[sectionKey] = null
  }

  getEmptyError = () => ({
    type: "",
    message: "",
    fields: [],
  })

  setSectionError = (sectionKey, type, message, fields = []) => {
    this.updateSection(sectionKey, {
      error: {
        type,
        message,
        fields,
      },
    })
  }

  clearSectionError = (sectionKey) => {
    this.updateSection(sectionKey, {
      error: this.getEmptyError(),
    })
  }

  hasFieldError = (section, fieldName) => {
    return section.error?.fields?.includes(fieldName)
  }

  getInputClassName = (section, fieldName, baseClassName) => {
    const hasError = this.hasFieldError(section, fieldName)

    return hasError ? `${baseClassName} has-error` : baseClassName
  }

  clearLeaveTimers = (sectionKey) => {
    ;[this.previewLeaveTimers, this.promptLeaveTimers].forEach((timers) => {
      if (timers[sectionKey]) {
        clearTimeout(timers[sectionKey])
        timers[sectionKey] = null
      }
    })
  }

  closePreviewMessage = (sectionKey) => {
    this.clearPreviewMessageTimer(sectionKey)

    if (this.previewLeaveTimers[sectionKey]) {
      clearTimeout(this.previewLeaveTimers[sectionKey])
    }

    this.updateSection(sectionKey, {
      isPreviewMessageVisible: false,
      isPreviewMessageLeaving: true,
    })

    this.previewLeaveTimers[sectionKey] = setTimeout(() => {
      this.updateSection(sectionKey, { isPreviewMessageLeaving: false })
      this.previewLeaveTimers[sectionKey] = null
    }, PREVIEW_LEAVE_DURATION)
  }

  textToHtml = (text, alignment = "left") => {
    if (!text) return ""

    const escapeHtml = (value) =>
      String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")

    return String(text)
      .split(/\r?\n/)
      .map((line) => {
        if (!line.trim()) {
          return `<p style="text-align: ${alignment}; margin: 0; line-height: 2;"><br></p>`
        }

        return `<p style="text-align: ${alignment}; margin: 0; line-height: 2;">${escapeHtml(line)}</p>`
      })
      .join("")
  }

  htmlToText = (html) => {
    if (!html) return ""

    const parser = new DOMParser()
    const doc = parser.parseFromString(String(html), "text/html")
    const paragraphs = Array.from(doc.body.children)

    if (paragraphs.length > 0) {
      return paragraphs
        .map((element) => element.innerText || element.textContent || "")
        .join("\n")
        .trim()
    }

    return doc.body.textContent || ""
  }

  getHtmlAlignment = (html) => {
    if (!html) return "left"

    const parser = new DOMParser()
    const doc = parser.parseFromString(String(html), "text/html")
    const element = doc.body.querySelector("[style*='text-align']")

    const alignment = element ? element.style.textAlign : "left"

    return ["left", "center", "right"].includes(alignment) ? alignment : "left"
  }

  /* -------------------------------------------------------------------------- */
  /* Form                                                                       */
  /* -------------------------------------------------------------------------- */

  handleTextChange = (sectionKey, fieldName) => (event) => {
    const section = this.getSection(sectionKey)

    const remainingFields = (section.error?.fields || []).filter((field) => field !== fieldName)

    this.updateSection(sectionKey, {
      [fieldName]: event.target.value,
      error: {
        ...section.error,
        fields: remainingFields,
        ...(remainingFields.length === 0
          ? {
              type: "",
              message: "",
            }
          : {}),
      },
    })
  }

  handleAlignmentChange = (sectionKey, fieldName, alignment) => {
    this.updateSection(sectionKey, {
      [fieldName]: alignment,
    })
  }

  handleDateChange = (sectionKey, fieldName) => (value) => {
    const section = this.getSection(sectionKey)
    const nextStartDate = fieldName === "startDate" ? value : section.startDate
    const nextEndDate = fieldName === "endDate" ? value : section.endDate
    const hasValidStartDate = nextStartDate && moment(nextStartDate).isValid()
    const hasValidEndDate = nextEndDate && moment(nextEndDate).isValid()

    const hasInvalidSchedule =
      hasValidStartDate &&
      hasValidEndDate &&
      moment(nextEndDate).isSameOrBefore(moment(nextStartDate))

    // ถ้าเป็น date error และ user แก้ date จนถูกต้องแล้ว
    if (section.error?.type === "date" && !hasInvalidSchedule) {
      this.updateSection(sectionKey, {
        [fieldName]: value,
        error: this.getEmptyError(),
      })

      return
    }

    this.updateSection(sectionKey, {
      [fieldName]: value,
    })
  }

  handleStartEdit = (sectionKey) => {
    this.updateSection(sectionKey, {
      isEditing: true,
      error: this.getEmptyError(),
    })
  }

  handleCancelEdit = (sectionKey) => {
    const section = this.getSection(sectionKey)

    this.updateSection(sectionKey, {
      subjectTH: section.savedForm.subjectTH,
      messageTH: section.savedForm.messageTH,
      subjectEN: section.savedForm.subjectEN,
      messageEN: section.savedForm.messageEN,
      messageAlignmentTH: section.savedForm.messageAlignmentTH || "left",
      messageAlignmentEN: section.savedForm.messageAlignmentEN || "left",
      startDate: section.savedForm.startDate
        ? new Date(section.savedForm.startDate.getTime())
        : null,
      endDate: section.savedForm.endDate ? new Date(section.savedForm.endDate.getTime()) : null,
      isEditing: false,
      error: this.getEmptyError(),
    })
  }

  handleSaveEdit = async (sectionKey) => {
    const section = this.getSection(sectionKey)

    // กันกด Save ซ้ำ
    if (section.isSaving) {
      return
    }

    if (this.isInvalidSchedule(section)) {
      this.setSectionError(
        sectionKey,
        "date",
        "End date and time must be later than start date and time.",
        ["startDate", "endDate"]
      )

      return
    }

    const isWebsite = sectionKey === WEBSITE_SECTION

    const payload = {
      subject_th: section.subjectTH,
      message_th: isWebsite
        ? this.textToHtml(section.messageTH, section.messageAlignmentTH)
        : section.messageTH,
      subject_en: section.subjectEN,
      message_en: isWebsite
        ? this.textToHtml(section.messageEN, section.messageAlignmentEN)
        : section.messageEN,
      start_datetime: moment(section.startDate).format("YYYY-MM-DD HH:mm:ss"),
      end_datetime: moment(section.endDate).format("YYYY-MM-DD HH:mm:ss"),
      is_active: Boolean(section.isActive),
    }

    // lock ปุ่ม Save ก่อนยิง API
    this.updateSection(sectionKey, {
      isSaving: true,
      error: this.getEmptyError(),
    })

    try {
      const isFirstSave = !section.id

      const response = isFirstSave
        ? await request.post("announcement-cs/add", {
            type: sectionKey,
            ...payload,
          })
        : await request.put(`announcement-cs/${section.id}/update`, payload)

      const responseData = response?.data || response

      if (responseData && responseData.message !== "Done") {
        throw new Error("Save announcement failed")
      }

      this.updateSection(sectionKey, {
        id: section.id,
        isActive: section.isActive,
        isEditing: false,
        isSaving: false,
        savedForm: {
          subjectTH: section.subjectTH,
          messageTH: section.messageTH,
          subjectEN: section.subjectEN,
          messageEN: section.messageEN,
          messageAlignmentTH: section.messageAlignmentTH || "left",
          messageAlignmentEN: section.messageAlignmentEN || "left",
          startDate: section.startDate ? new Date(section.startDate.getTime()) : null,
          endDate: section.endDate ? new Date(section.endDate.getTime()) : null,
        },
        isSuccessModalVisible: true,
        error: this.getEmptyError(),
      })

      this.startSuccessModalTimer(sectionKey)
    } catch (error) {
      console.error("handleSaveEdit error:", error)

      this.setSectionError(sectionKey, "submit", "Unable to save announcement. Please try again.")

      this.updateSection(sectionKey, {
        isSaving: false,
        isEditing: true,
      })
    }
  }

  startSuccessModalTimer = (sectionKey) => {
    if (this.successModalTimers[sectionKey]) {
      clearTimeout(this.successModalTimers[sectionKey])
    }

    this.successModalTimers[sectionKey] = setTimeout(() => {
      this.closeSuccessModal(sectionKey)
    }, SUCCESS_MODAL_DURATION)
  }

  /* -------------------------------------------------------------------------- */
  /* Preview                                                                    */
  /* -------------------------------------------------------------------------- */

  clearPreviewMessageTimer = (sectionKey) => {
    if (this.previewMessageTimers[sectionKey]) {
      clearTimeout(this.previewMessageTimers[sectionKey])
      this.previewMessageTimers[sectionKey] = null
    }
  }

  handleTogglePreview = (sectionKey) => {
    const section = this.getSection(sectionKey)
    const isOpening = !section.isPreviewVisible
    const isWebsiteSection = sectionKey === WEBSITE_SECTION

    this.clearPreviewMessageTimer(sectionKey)
    this.clearLeaveTimers(sectionKey)

    this.updateSection(sectionKey, {
      isPreviewVisible: isOpening,
      isPreviewMessageVisible: isOpening && isWebsiteSection,
      isPreviewMessageLeaving: false,
      isPreviewPromptLeaving: false,
      isPreviewAtBottom: false,
      isPreviewScrolling: false,
      hasOpenedPreviewMessage: isOpening && isWebsiteSection,
    })

    if (isOpening && isWebsiteSection) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.updatePreviewPopupPosition()
        })
      })

      this.previewMessageTimers[sectionKey] = setTimeout(() => {
        this.closePreviewMessage(sectionKey)
        this.previewMessageTimers[sectionKey] = null
      }, PREVIEW_MESSAGE_DURATION)
    }
  }

  handleChangePreviewLanguage = (sectionKey, previewLanguage) => {
    this.updateSection(sectionKey, {
      previewLanguage,
    })
  }

  handlePreviewStageScroll = (sectionKey) => {
    const stage = this.previewStageRefs[sectionKey]?.current
    if (!stage) {
      return
    }

    const section = this.getSection(sectionKey)
    const isBottom = stage.scrollTop + stage.clientHeight >= stage.scrollHeight - 5
    const updates = { isPreviewScrolling: true }

    if (isBottom !== section.isPreviewAtBottom) {
      updates.isPreviewAtBottom = isBottom

      if (isBottom) {
        updates.hasOpenedPreviewMessage = section.isPreviewMessageVisible
      } else {
        if (section.isPreviewMessageVisible) {
          this.closePreviewMessage(sectionKey)
        } else {
          this.clearPreviewMessageTimer(sectionKey)
        }
        updates.hasOpenedPreviewMessage = false
      }
    }

    this.updateSection(sectionKey, updates)

    if (this.previewScrollTimers[sectionKey]) {
      clearTimeout(this.previewScrollTimers[sectionKey])
    }
    this.previewScrollTimers[sectionKey] = setTimeout(() => {
      this.updateSection(sectionKey, { isPreviewScrolling: false })
      this.previewScrollTimers[sectionKey] = null
    }, 140)
  }

  handlePreviewMessage = (sectionKey) => {
    const section = this.getSection(sectionKey)
    this.clearPreviewMessageTimer(sectionKey)

    // close manually
    if (section.isPreviewMessageVisible) {
      this.closePreviewMessage(sectionKey)
      return
    }

    const isPromptShowing = section.isPreviewAtBottom && !section.hasOpenedPreviewMessage

    if (isPromptShowing) {
      if (this.promptLeaveTimers[sectionKey]) {
        clearTimeout(this.promptLeaveTimers[sectionKey])
      }

      this.promptLeaveTimers[sectionKey] = setTimeout(() => {
        this.updateSection(sectionKey, { isPreviewPromptLeaving: false })
        this.promptLeaveTimers[sectionKey] = null
      }, PREVIEW_LEAVE_DURATION)
    }

    if (this.previewLeaveTimers[sectionKey]) {
      clearTimeout(this.previewLeaveTimers[sectionKey])
      this.previewLeaveTimers[sectionKey] = null
    }

    // open + auto hide
    this.updateSection(sectionKey, {
      isPreviewMessageVisible: true,
      isPreviewMessageLeaving: false,
      isPreviewPromptLeaving: isPromptShowing,
      hasOpenedPreviewMessage: section.isPreviewAtBottom,
    })

    this.previewMessageTimers[sectionKey] = setTimeout(() => {
      this.closePreviewMessage(sectionKey)
      this.previewMessageTimers[sectionKey] = null
    }, PREVIEW_MESSAGE_DURATION)
  }

  updatePreviewPopupPosition = () => {
    const popup = this.previewPopupRef.current
    const row = this.previewCharacterRef.current
    const wrapper = row?.parentElement

    if (!popup || !row || !wrapper) {
      return
    }

    const rowRect = row.getBoundingClientRect()
    const wrapperRect = wrapper.getBoundingClientRect()

    const centerOffset = (popup.offsetHeight - row.offsetHeight) / 2
    const spaceBelow = wrapperRect.bottom - rowRect.bottom
    const maxOffset = Math.max(spaceBelow - PREVIEW_POPUP_BOTTOM_GAP, 0)

    popup.style.setProperty(
      "--announcement-popup-offset",
      `${Math.max(Math.min(centerOffset, maxOffset), 0)}px`
    )
  }

  /* -------------------------------------------------------------------------- */
  /* Activation                                                                 */
  /* -------------------------------------------------------------------------- */

  handleToggleActivation = (sectionKey, title) => {
    const section = this.getSection(sectionKey)

    if (!section.isActive && this.shouldShowExpiredWarning(sectionKey)) {
      this.openNoticeModal(sectionKey)
      return
    }

    this.setState({
      activationConfirm: {
        isOpen: true,
        sectionKey,
        title,
        action: section.isActive ? "deactivate" : "activate",
      },
    })
  }

  closeActivationConfirmModal = () => {
    this.setState({
      activationConfirm: createActivationConfirmState(),
    })
  }

  openNoticeModal = (sectionKey) => {
    this.setState({
      activationConfirm: createActivationConfirmState(),
      noticeModal: {
        isOpen: true,
        sectionKey,
      },
    })
  }

  closeNoticeModal = () => {
    this.setState({
      noticeModal: {
        isOpen: false,
        sectionKey: null,
      },
    })
  }

  confirmToggleActivation = async () => {
    const { activationConfirm } = this.state
    const { sectionKey } = activationConfirm

    if (!sectionKey) {
      this.closeActivationConfirmModal()

      return
    }

    const section = this.getSection(sectionKey)

    // Prevent double click / duplicate API request
    if (section.isSaving) {
      return
    }

    const nextIsActive = !section.isActive

    if (nextIsActive && this.shouldShowExpiredWarning(sectionKey)) {
      this.openNoticeModal(sectionKey)
      return
    }

    const payload = {
      is_active: nextIsActive,
    }

    if (nextIsActive && this.hasEmptyFields(section)) {
      const requiredFields = []

      if (!section.subjectTH || !section.subjectTH.trim()) {
        requiredFields.push("subjectTH")
      }

      if (!section.messageTH || !section.messageTH.trim()) {
        requiredFields.push("messageTH")
      }

      if (!section.subjectEN || !section.subjectEN.trim()) {
        requiredFields.push("subjectEN")
      }

      if (!section.messageEN || !section.messageEN.trim()) {
        requiredFields.push("messageEN")
      }

      this.setSectionError(
        sectionKey,
        "required",
        "Subject and message are required before activation.",
        requiredFields
      )

      this.closeActivationConfirmModal()

      return
    }

    if (nextIsActive && this.isInvalidSchedule(section)) {
      this.setSectionError(
        sectionKey,
        "date",
        "End date and time must be later than start date and time.",
        ["startDate", "endDate"]
      )

      this.closeActivationConfirmModal()

      return
    }

    // Lock immediately before API request
    this.updateSection(sectionKey, {
      isSaving: true,
    })

    try {
      const response = section.id
        ? await request.put(`announcement-cs/${section.id}/update`, payload)
        : await request.post("announcement-cs/add", {
            type: sectionKey,
            ...payload,
          })

      const responseData = response?.data || response

      if (responseData && responseData.message !== "Done") {
        throw new Error("Update announcement status failed")
      }

      const savedId = section.id || null
      this.updateSection(sectionKey, {
        id: savedId,
        isActive: nextIsActive,
        isSaving: false,
        error: this.getEmptyError(),
      })

      this.closeActivationConfirmModal()
    } catch (error) {
      console.error("confirmToggleActivation error:", error)

      this.setSectionError(sectionKey, "submit", "Unable to save announcement. Please try again.")
      this.updateSection(sectionKey, {
        isSaving: false,
      })

      this.closeActivationConfirmModal()
    }
  }

  /* -------------------------------------------------------------------------- */
  /* Render: Preview Modal                                                      */
  /* -------------------------------------------------------------------------- */

  renderPreviewModal = (sectionKey, title) => {
    const section = this.getSection(sectionKey)

    if (!section.isPreviewVisible) {
      return null
    }

    const isEmailSection = sectionKey === EMAIL_SECTION

    return (
      <div
        className="cs-announcement-modal-overlay"
        onClick={() => this.handleTogglePreview(sectionKey)}>
        <div className="cs-announcement-modal" onClick={(event) => event.stopPropagation()}>
          <div
            className={
              isEmailSection
                ? "cs-announcement-modal-header"
                : "cs-announcement-modal-header has-language-switch"
            }>
            <h3 className="cs-announcement-modal-title">{title} Preview</h3>

            {!isEmailSection && (
              <div className="cs-announcement-preview-language-switch">
                <button
                  type="button"
                  className={
                    section.previewLanguage === "th"
                      ? "cs-announcement-preview-language-button is-active"
                      : "cs-announcement-preview-language-button"
                  }
                  onClick={() => this.handleChangePreviewLanguage(sectionKey, "th")}>
                  TH
                </button>

                <button
                  type="button"
                  className={
                    section.previewLanguage === "en"
                      ? "cs-announcement-preview-language-button is-active"
                      : "cs-announcement-preview-language-button"
                  }
                  onClick={() => this.handleChangePreviewLanguage(sectionKey, "en")}>
                  EN
                </button>
              </div>
            )}
          </div>

          <div>
            {isEmailSection
              ? this.renderEmailPreview(section)
              : this.renderWebsitePreview(sectionKey, section)}

            {this.renderPreviewMeta(section)}

            <div className="cs-announcement-close-wrapper">
              <button
                type="button"
                className="cs-announcement-close-preview-button"
                onClick={() => this.handleTogglePreview(sectionKey)}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderEmailPreview = (section) => {
    return (
      <div className="cs-announcement-email-preview">
        <div className="cs-announcement-email-box">
          <div className="cs-announcement-email-message-wrapper">
            <img src={EmailHeaderImage} alt="Email Header" />

            <div className="cs-announcement-email-header-content">
              <img src={OffIcon} alt="Off Icon" />
              <span className="cs-announcement-email-header">
                {section.subjectTH || "ไม่มีหัวข้อ"} | {section.subjectEN || "No subject content"}
              </span>
            </div>

            <div className="cs-announcement-email-message-content">
              <span className="cs-announcement-email-message">
                {section.messageTH || "ไม่มีเนื้อหาข้อความ"}
                <hr />
                {section.messageEN || "No message content"}
              </span>
            </div>

            <div className="cs-announcement-email-contact-content">
              <span className="cs-announcement-email-contact">ติดต่อเรา | Contact us</span>
              <img src={ContactEmail} alt="Contact Email" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderWebsitePreview = (sectionKey, section) => {
    const previewLanguage = section.previewLanguage === "en" ? "en" : "th"

    const subject =
      previewLanguage === "th"
        ? section.subjectTH || "💬 แจ้งเตือนจาก Customer Support"
        : section.subjectEN || "💬 Customer Support Announcement"

    const message =
      previewLanguage === "th"
        ? section.messageTH || "ไม่มีเนื้อหาข้อความ"
        : section.messageEN || "No message content"

    const showPrompt =
      section.isPreviewAtBottom &&
      !section.isPreviewMessageVisible &&
      !section.isPreviewMessageLeaving &&
      !section.hasOpenedPreviewMessage

    const renderPrompt = showPrompt || section.isPreviewPromptLeaving
    const renderPopup = section.isPreviewMessageVisible || section.isPreviewMessageLeaving

    return (
      <div className="cs-announcement-character-preview">
        <div className="cs-announcement-character-stage-wrapper">
          {/* Scrollable fake website */}
          <div
            className="cs-announcement-character-stage"
            ref={this.previewStageRefs[sectionKey]}
            onScroll={() => this.handlePreviewStageScroll(sectionKey)}>
            <div className="cs-announcement-fake-page">
              <div className="cs-announcement-fake-header">
                <img src={WebsiteLogoImage} alt="Website Logo" />
              </div>
              <div className="cs-announcement-fake-content">
                <span>scroll to the bottom to show the subject.</span>
              </div>
              <div className="cs-announcement-fake-footer" />
            </div>
          </div>

          {/* Floating overlay */}
          <div className="cs-announcement-character-row" ref={this.previewCharacterRef}>
            {renderPrompt && (
              <button
                type="button"
                className={
                  section.isPreviewPromptLeaving
                    ? "cs-announcement-character-prompt is-leaving"
                    : "cs-announcement-character-prompt"
                }
                onClick={() => this.handlePreviewMessage(sectionKey)}>
                <span dangerouslySetInnerHTML={{ __html: subject }} />
              </button>
            )}

            {renderPopup && (
              <div className="cs-announcement-character-bubbles">
                <div
                  className={
                    section.isPreviewMessageLeaving
                      ? "cs-announcement-character-popup is-leaving"
                      : "cs-announcement-character-popup"
                  }
                  ref={(element) => {
                    this.previewPopupRef.current = element
                    if (element) {
                      this.updatePreviewPopupPosition()
                    }
                  }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.textToHtml(
                        message === "ไม่มีเนื้อหาข้อความ" || message === "No message content"
                          ? ""
                          : message,
                        previewLanguage === "th"
                          ? section.messageAlignmentTH
                          : section.messageAlignmentEN
                      ),
                    }}
                  />
                </div>
              </div>
            )}

            <button
              type="button"
              className={
                section.isPreviewScrolling
                  ? "cs-announcement-character-button is-dimmed"
                  : "cs-announcement-character-button"
              }
              aria-label="Toggle announcement message"
              onClick={() => this.handlePreviewMessage(sectionKey)}>
              <img src={CSCharacterImage} alt="CS Character" />
            </button>
          </div>
        </div>

        <div className="cs-announcement-preview-hint">
          Click the character or subject to toggle the message.
        </div>
      </div>
    )
  }

  renderPreviewMeta = (section) => {
    return (
      <div className="cs-announcement-preview-meta">
        <div>
          Start:{" "}
          {section.startDate ? moment(section.startDate).format("DD/MM/YYYY [[]HH:mm[]]") : "-"}
        </div>

        <div>
          End: {section.endDate ? moment(section.endDate).format("DD/MM/YYYY [[]HH:mm[]]") : "-"}
        </div>
      </div>
    )
  }

  /* -------------------------------------------------------------------------- */
  /* Render: Activation Modal                                                   */
  /* -------------------------------------------------------------------------- */

  renderActivationConfirmModal = () => {
    const { activationConfirm } = this.state

    if (!activationConfirm.isOpen || !activationConfirm.sectionKey) {
      return null
    }

    const { sectionKey } = activationConfirm
    const section = this.getSection(sectionKey)

    const actionLabel = activationConfirm.action === "deactivate" ? "deactivate" : "activate"

    const title = this.getActivationConfirmTitle(activationConfirm.title)

    return (
      <div className="cs-announcement-modal-overlay">
        <div className="cs-confirm-modal">
          <h3 className="cs-confirm-modal-title">Are you sure?</h3>

          <p className="cs-confirm-text">
            Are you sure you want to {actionLabel} {title}?
          </p>

          <div className="cs-confirm-actions">
            <button
              type="button"
              className="cs-cancel-button"
              onClick={this.closeActivationConfirmModal}>
              Cancel
            </button>

            <button
              type="button"
              className="cs-confirm-button"
              disabled={section.isSaving}
              onClick={this.confirmToggleActivation}>
              {section.isSaving ? "Processing..." : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    )
  }

  /* -------------------------------------------------------------------------- */
  /* Render: Success Modal                                                      */
  /* -------------------------------------------------------------------------- */

  renderSuccessModal = (sectionKey) => {
    const section = this.getSection(sectionKey)

    if (!section.isSuccessModalVisible) {
      return null
    }

    return (
      <div className="cs-announcement-modal-overlay">
        <div className="cs-confirm-modal">
          <div className="cs-success-modal-body">
            <img src={SuccessIcon} alt="Success" className="cs-success-icon" />

            <p className="cs-confirm-text">The announcement has been saved successfully.</p>
          </div>
        </div>
      </div>
    )
  }

  /* -------------------------------------------------------------------------- */
  /* Render: notice Modal                                                   */
  /* -------------------------------------------------------------------------- */

  renderNoticeModal = () => {
    const { noticeModal } = this.state

    if (!noticeModal.isOpen) {
      return null
    }

    return (
      <div className="cs-announcement-modal-overlay" onClick={this.closeNoticeModal}>
        <div className="cs-notice-modal" onClick={(event) => event.stopPropagation()}>
          <h3 className="cs-confirm-modal-title">Notice</h3>

          <p className="cs-confirm-text">
            The end date has passed. Please update the end date to continue using this announcement.
          </p>

          <div className="cs-confirm-actions">
            <button type="button" className="cs-confirm-button" onClick={this.closeNoticeModal}>
              OK
            </button>
          </div>
        </div>
      </div>
    )
  }

  /* -------------------------------------------------------------------------- */
  /* Render: Section                                                            */
  /* -------------------------------------------------------------------------- */

  renderSection = (sectionKey, title) => {
    const section = this.getSection(sectionKey)
    const sectionStatus = this.getSectionStatus(sectionKey)
    const isSectionActivated = section.isActive
    const isSaveDisabled = section.isSaving || this.hasMissingRequiredFields(section)

    return (
      <div className="cs-announcement-section-card">
        <div className="cs-announcement-section-header-row">
          <div className="section-header-info">
            <h2 className="cs-announcement-section-title">{title}</h2>

            <div className="cs-announcement-status-control">
              {!section.isEditing && (
                <div className="cs-announcement-status-value">
                  <span
                    className={
                      isSectionActivated
                        ? "cs-announcement-status-dot is-active"
                        : "cs-announcement-status-dot"
                    }
                  />

                  <span>{sectionStatus}</span>

                  <button
                    type="button"
                    className={
                      isSectionActivated
                        ? "cs-announcement-status-switch is-active"
                        : "cs-announcement-status-switch"
                    }
                    onClick={() =>
                      this.handleToggleActivation(sectionKey, this.getActivationConfirmTitle(title))
                    }>
                    <span
                      className={
                        isSectionActivated
                          ? "cs-announcement-status-switch-knob is-active"
                          : "cs-announcement-status-switch-knob"
                      }
                    />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="cs-action-row">
            <button
              type="button"
              className="cs-announcement-preview-button"
              onClick={() => this.handleTogglePreview(sectionKey)}>
              Preview
            </button>
            <div className="cs-announcement-action-row">
              {section.isEditing ? (
                <Fragment>
                  <button
                    type="button"
                    className="cancel-button"
                    onClick={() => this.handleCancelEdit(sectionKey)}>
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="cs-success-button"
                    disabled={isSaveDisabled}
                    onClick={() => this.handleSaveEdit(sectionKey)}>
                    {section.isSaving ? "Saving..." : "Save"}
                  </button>
                </Fragment>
              ) : (
                <button
                  type="button"
                  className="cs-success-button"
                  onClick={() => this.handleStartEdit(sectionKey)}>
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>

        {this.shouldShowExpiredWarning(sectionKey) && !section.isEditing && (
          <div className="warning-section">
            <img src={WarningIcon} alt="Warning" className="warning-icon" />
            <p>
              The end date has passed. Please update the end date to continue using this
              announcement.
            </p>
          </div>
        )}

        <div className="cs-announcement-section-body">
          {section.isExpanded && this.renderForm(sectionKey, section)}
        </div>

        {this.renderPreviewModal(sectionKey, title)}

        {this.renderSuccessModal(sectionKey)}
      </div>
    )
  }

  renderForm = (sectionKey, section) => {
    const error = section.error || this.getEmptyError()
    const showTopError = error.message && (error.type === "required" || error.type === "submit")
    const showDateError = error.message && error.type === "date"

    return (
      <div>
        <div className="cs-announcement-form-grid">
          {/* Required / Submit Error */}
          {showTopError && (
            <div className="cs-announcement-error-wrapper cs-announcement-error-wrapper-top">
              <p className="cs-announcement-error-text">{error.message}</p>
            </div>
          )}

          {/* Start Date */}
          <div className="cs-announcement-field-block">
            <label className="cs-announcement-field-label">Start Date & Time *</label>

            <DatePicker
              className={this.getInputClassName(
                section,
                "startDate",
                "cs-announcement-input cs-announcement-datepicker"
              )}
              selected={section.startDate}
              onChange={this.handleDateChange(sectionKey, "startDate")}
              disabled={!section.isEditing}
              showTimeSelect
              timeIntervals={TIME_INTERVALS}
              dateFormat="dd/MM/yyyy [HH:mm]"
            />
          </div>

          {/* End Date */}
          <div className="cs-announcement-field-block">
            <label className="cs-announcement-field-label">End Date & Time *</label>

            <DatePicker
              className={this.getInputClassName(
                section,
                "endDate",
                "cs-announcement-input cs-announcement-datepicker"
              )}
              selected={section.endDate}
              onChange={this.handleDateChange(sectionKey, "endDate")}
              disabled={!section.isEditing}
              showTimeSelect
              minDate={new Date()}
              timeIntervals={TIME_INTERVALS}
              dateFormat="dd/MM/yyyy [HH:mm]"
            />
          </div>

          {/* Date Error */}
          {showDateError && (
            <div className="cs-announcement-error-wrapper cs-announcement-error-wrapper-date">
              <p className="cs-announcement-error-text">{error.message}</p>
            </div>
          )}

          {/* Subject TH */}
          <div className="cs-announcement-field-block cs-announcement-field-block-full">
            <label className="cs-announcement-field-label">Subject (TH) *</label>

            <input
              className="cs-announcement-input"
              type="text"
              placeholder="Enter announcement subject"
              value={section.subjectTH || ""}
              disabled={!section.isEditing}
              onChange={this.handleTextChange(sectionKey, "subjectTH")}
              maxLength={255}
            />
          </div>

          {/* Message TH */}
          <div className="cs-announcement-field-block cs-announcement-field-block-full">
            <label className="cs-announcement-field-label">Message (TH) *</label>

            {sectionKey === WEBSITE_SECTION && section.isEditing && (
              <div className="cs-announcement-alignment-toolbar">
                {[
                  { value: "left", label: "Left" },
                  { value: "center", label: "Center" },
                  { value: "right", label: "Right" },
                ].map((item) => (
                  <button
                    key={item.value}
                    type="button"
                    className={
                      section.messageAlignmentTH === item.value
                        ? "cs-announcement-alignment-button is-active"
                        : "cs-announcement-alignment-button"
                    }
                    disabled={!section.isEditing}
                    onClick={() =>
                      this.handleAlignmentChange(sectionKey, "messageAlignmentTH", item.value)
                    }>
                    {item.label}
                  </button>
                ))}
              </div>
            )}

            <textarea
              className="cs-announcement-textarea"
              placeholder="Write the announcement message"
              value={section.messageTH || ""}
              disabled={!section.isEditing}
              onChange={this.handleTextChange(sectionKey, "messageTH")}
              style={{
                textAlign: section.messageAlignmentTH || "left",
              }}
            />
          </div>

          {/* Subject EN */}
          <div className="cs-announcement-field-block cs-announcement-field-block-full">
            <label className="cs-announcement-field-label">Subject (EN) *</label>

            <input
              className="cs-announcement-input"
              type="text"
              placeholder="Enter announcement subject"
              value={section.subjectEN || ""}
              disabled={!section.isEditing}
              onChange={this.handleTextChange(sectionKey, "subjectEN")}
              maxLength={255}
            />
          </div>

          {/* Message EN */}
          <div className="cs-announcement-field-block cs-announcement-field-block-full">
            <label className="cs-announcement-field-label">Message (EN) *</label>

            {sectionKey === WEBSITE_SECTION && section.isEditing && (
              <div className="cs-announcement-alignment-toolbar">
                {[
                  { value: "left", label: "Left" },
                  { value: "center", label: "Center" },
                  { value: "right", label: "Right" },
                ].map((item) => (
                  <button
                    key={item.value}
                    type="button"
                    className={
                      section.messageAlignmentEN === item.value
                        ? "cs-announcement-alignment-button is-active"
                        : "cs-announcement-alignment-button"
                    }
                    disabled={!section.isEditing}
                    onClick={() =>
                      this.handleAlignmentChange(sectionKey, "messageAlignmentEN", item.value)
                    }>
                    {item.label}
                  </button>
                ))}
              </div>
            )}

            <textarea
              className="cs-announcement-textarea"
              placeholder="Write the announcement message"
              value={section.messageEN || ""}
              disabled={!section.isEditing}
              onChange={this.handleTextChange(sectionKey, "messageEN")}
              style={{
                textAlign: section.messageAlignmentEN || "left",
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="cs-announcement-page-shell">
        <div className="cs-announcement-section-grid">
          {this.renderSection(WEBSITE_SECTION, "Website")}

          {this.renderSection(EMAIL_SECTION, "Email Auto-reply")}
        </div>

        {this.renderActivationConfirmModal()}
        {this.renderNoticeModal()}
      </div>
    )
  }
}

const mapDispatch = (dispatch) => ({
  setPageTitle: dispatch.Title.setPageTitle,

  showBackIcon: dispatch.Title.showBackIcon,
})

export default connect(null, mapDispatch)(BroadcasManagementLayout)
